import React, { useState, useEffect } from 'react';
import { api } from '../../api/client';
import { getSubdomainBaseUrl } from '../../utils/subdomain';

export default function CompanyPickerPage() {
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.getCompaniesList()
      .then(setCompanies)
      .catch(() => setCompanies([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.logo}>🚚</div>
        <h1 style={styles.title}>نظام إدارة الشحن</h1>
        <p style={styles.subtitle}>اختر شركة لتسجيل الدخول</p>

        {loading ? (
          <p style={{ textAlign: 'center', color: '#999' }}>جاري التحميل...</p>
        ) : (
          <div style={styles.companyList}>
            {companies.map((c) => {
              const subdomainUrl = getSubdomainBaseUrl(c.slug);
              const href = subdomainUrl ? subdomainUrl + '/login' : '/' + c.slug + '/login';
              return (
                <a key={c.id} href={href} style={styles.companyLink}>
                  <span style={styles.companyIcon}>🏢</span>
                  <span style={styles.companyName}>{c.name}</span>
                  <span style={styles.companySlug} dir="ltr">{c.slug}</span>
                </a>
              );
            })}
          </div>
        )}

        <div style={styles.note}>
          <p style={styles.noteText}>يمكن لكل شركة الدخول عبر رابط مخصص باستخدام النطاق الفرعي</p>
        </div>

        <div style={styles.adminLink}>
          <a href="/admin/login" style={styles.adminLinkText}>تسجيل دخول مدير النظام</a>
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    display: 'flex', justifyContent: 'center', alignItems: 'center',
    minHeight: '100vh', backgroundColor: 'var(--color-primary)',
  },
  card: {
    backgroundColor: 'white', borderRadius: 'var(--radius-lg)',
    padding: 'var(--sp-4xl)', width: '100%', maxWidth: '420px',
    boxShadow: 'var(--shadow-xl)', textAlign: 'center',
  },
  logo: { fontSize: '48px', marginBottom: '8px' },
  title: { fontSize: 'var(--font-size-2xl)', color: 'var(--color-primary)', margin: '0 0 4px 0' },
  subtitle: { fontSize: 'var(--font-size-base)', color: 'var(--color-text-secondary)', margin: '0 0 24px 0' },
  companyList: { display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '20px' },
  companyLink: {
    display: 'flex', alignItems: 'center', gap: '12px',
    padding: '14px 16px', borderRadius: 'var(--radius-md)',
    backgroundColor: '#f8f9fa', textDecoration: 'none',
    transition: 'background-color 0.2s', textAlign: 'right',
    border: '1px solid var(--color-border)',
  },
  companyIcon: { fontSize: '24px', flexShrink: 0 },
  companyName: { flex: 1, fontSize: '14px', fontWeight: '600', color: '#333' },
  companySlug: { fontSize: '12px', color: '#999', direction: 'ltr' },
  note: { marginTop: '12px', marginBottom: '8px', padding: '8px 12px', backgroundColor: '#EDE7F6', borderRadius: 'var(--radius-sm)' },
  noteText: { fontSize: '11px', color: '#5c6bc0', margin: 0, lineHeight: 1.5 },
  adminLink: { marginTop: '8px', paddingTop: '16px', borderTop: '1px solid #eee' },
  adminLinkText: {
    fontSize: '13px', color: 'var(--color-primary)', textDecoration: 'none',
    fontWeight: '600',
  },
};
